import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/PlataformaLogin";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/plataforma/login")({
  head: () => pageHead({ title: "Login | Plataforma | Clara Camille", path: "/plataforma/login", noindex: true }),
  validateSearch: (search: Record<string, unknown>): { email?: string } =>
    typeof search.email === "string" ? { email: search.email } : {},
  component: Page,
});
